import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { useFormik } from "formik";
import * as yup from "yup";
import Dropzone from 'react-dropzone'
import { useSnackbar } from 'notistack';
import { Button, Chip, Grid, Stack, TextField } from '@mui/material'
import BackupIcon from "@mui/icons-material/Backup";
import { makeStyles } from "@mui/styles";
import { ButtonSubmitProgress } from '../../../components/form/Buttons'
import { objectToFormData } from '../../../Utils/formUtils.js'
import { newComment } from '../../../Store/Ducks/duckTicketsComments';
import { snackAction } from '../../../components/CustomSnakbar.jsx'

const validationSchema = yup.object({
    Comment: yup
        .string("Ingrese un Comentario")
        .required("El Comentario es requerido"),
});

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: "10px",
        marginBottom: "10px",
    },
    chip: { marginTop: "15px" }
}));

export const TicketNewComment = ({ ticketNumber, handleClose, supplierTickets, setOpenNewComment, setUpdateComment }) => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();

    const [onSubmit, setOnSubmit] = useState(false)
    const [selectedFiles, setFiles] = useState([]);

    const onDrop = (cfiles) => {
        if (cfiles.length > 0) {
            const newFiles = cfiles.filter((file) => {
                for (let i = 0; i < selectedFiles.length; i++) {
                    if (selectedFiles[i].name === file.name && selectedFiles[i].size === file.size) {
                        return false;
                    }
                }
                return true;
            });
            setFiles([...selectedFiles, ...newFiles]);
        }
    };

    const handleClickCancel = () => {
        setOpenNewComment(false);
    }

    const handleDelete = (fileToDelete) => {
        const newFiles = selectedFiles.filter((file) => file !== fileToDelete);
        setFiles(newFiles);
    }

    const formik = useFormik({
        initialValues: {
            Comment: ''
        },
        validationSchema: validationSchema,

        onSubmit: (values, { resetForm }) => {
            setOnSubmit(true)
            let formData = objectToFormData({ ...values, TicketNumber: ticketNumber, Author_id: supplierTickets.invgate_UserID });
            for (let i = 0; i < selectedFiles.length; i++) {
                const element = selectedFiles[i];
                formData.append("Attachments", element)
            }
            /* for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
            } */
            /* setOnSubmit(false) */

            dispatch(newComment(formData)).then(res => {
                enqueueSnackbar(`Se ha cargado su comentario correctamente`, { variant: "success", action: snackAction, autoHideDuration: 3000 });
                setUpdateComment(true)
                setOnSubmit(false)
                handleClose()
            })
                .catch(err => {
                    console.dir(err)
                    enqueueSnackbar(err.message, { variant: "error", action: snackAction, autoHideDuration: null });
                    resetForm();
                    setOnSubmit(false)
                });
        },
    });

    return (

        <div style={{ width: "100%" }}>
            <form>
                <TextField
                    id="Comment"
                    name="Comment"
                    label="Comentario"
                    margin="dense"
                    color="success"
                    focused
                    fullWidth
                    multiline
                    rows={5}
                    className={classes.formControl}
                    value={formik.values.Comment}
                    onChange={formik.handleChange}
                />

                <div className={classes.formControl}>
                    <Dropzone onDrop={onDrop}>
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div {...getRootProps({ className: "dropzone" })}>
                                    <input {...getInputProps({ multiple: true })} />
                                    {selectedFiles &&
                                        Array.isArray(selectedFiles) &&
                                        selectedFiles.length > 0 ? selectedFiles.map((file, index) => (
                                            <div key={index}>
                                                <Chip
                                                    className={classes.chip}
                                                    label={file.name}
                                                    variant="outlined"
                                                    onDelete={() => handleDelete(file)}
                                                />
                                            </div>
                                        )) : (
                                        <>
                                            <BackupIcon />
                                            <p>
                                                Arrastra los archivos aquí o <u>explora</u>
                                            </p>
                                        </>
                                    )}
                                </div>
                                <aside className="selected-file-wrapper"></aside>
                            </section>
                        )}
                    </Dropzone>
                </div>

                <div style={{ marginTop: 4, alignContent: "end" }}>
                    <Grid container >
                        <Grid item xs={6}>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="flex-end"
                            >
                                <Button color="error" onClick={handleClickCancel} variant="outlined">
                                    Cancelar
                                </Button>
                                <ButtonSubmitProgress color="primary" loading={onSubmit} variant="contained" onClick={formik.handleSubmit}>
                                    Enviar
                                </ButtonSubmitProgress>
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
            </form>
        </div>
    )
}
